module.exports = __webpack_public_path__ + "img/v7.555bef8d.png";